module.exports = __webpack_public_path__ + "img/work.fd3d2b0f.gif";